export default "__VITE_ASSET__CcBX4AUB__"